import React, { useRef, useEffect } from 'react';
import { useInView } from 'framer-motion';

const InlineVideo = ({ vidLink }) => {
  let vidRef = useRef();
  const isInView = useInView(vidRef);

  useEffect(() => {
    console.log('Element is in view: ', isInView);
    // vidRef.current.load();
    vidRef.current.play();
  }, [isInView]);

  return (
    <div className="inlineVid">
      <video ref={vidRef} playsInline width="320" height="240" muted="muted" controls>
        <source src={vidLink} type="video/mp4" />
      </video>
    </div>
  );
};

export default InlineVideo;
